// src/components/operationCenter/widgets/FearGreedWidget.tsx
// Widget wrapper for Fear & Greed index

import React, { useRef, useState, useEffect } from "react";
import type { WidgetProps, FearGreedConfig } from "@/types/dashboard";
import { FearGreedGauge } from "@/components/indices/FearGreedGauge";

const FearGreedWidget: React.FC<WidgetProps<FearGreedConfig>> = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [containerHeight, setContainerHeight] = useState(250);

  // Measure container height for ECharts
  useEffect(() => {
    const updateHeight = () => {
      if (containerRef.current) {
        const height = containerRef.current.clientHeight;
        if (height > 0) {
          setContainerHeight(height);
        }
      }
    };

    updateHeight();
    
    const resizeObserver = new ResizeObserver(updateHeight);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => resizeObserver.disconnect();
  }, []);

  return (
    <div ref={containerRef} className="h-full w-full flex items-center justify-center overflow-hidden">
      <FearGreedGauge height={`${containerHeight}px`} />
    </div>
  );
};

export default FearGreedWidget;
